/// <amd-module name="Test/TrendChartView/Actions/TrendChartActions" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { ITrendChartData } from "Test/Analytics/TrendChartCommon/Types";
import { Action } from "VSS/Reflux/Action";

export class TrendChartActions {
    public updateConfigurationValuesAction: Action<CommonTypes.IReportConfiguration> = new Action<CommonTypes.IReportConfiguration>();
    public updateTrendChartMetricAction: Action<CommonTypes.Metric> = new Action<CommonTypes.Metric>();
    public updateTrendChartAction: Action<ITrendChartData> = new Action<ITrendChartData>();
    public onError = new Action<Error>();
}
